<template>
  <v-row align="center" justify="center" no-gutters style="position: relative;">
    <div :style="{ width: (width*0.7)+'px', height: (height*0.7)+'px' }"
         style="background-color: white; position: absolute; transform: translate(-1px, -1px)"
    ></div>
    <div :id="id" class="paper" style="width: 80vh;height:80vh"></div>
  </v-row>
</template>

<style>
.paper {
  background-color: transparent;
  margin: auto;
}

.donthighlight {
  -moz-user-select: none;
  -webkit-user-select: none;
}
</style>

<script>
import Raphael from 'raphael'

export default {
  props: {id: {}, initState: {}, prevState: {}, axis: {}},
  name: "slw-chart",
  data() {
    return {
      width: '',
      height: '',
      paper: {},
      shrinkFactor: '',
      primaryColor: 'black',
      secondaryColor: 'lightgray',
      coverAreaColor: '#013B6C',
      colors: ['#939598', '#FED006', '#00AEEF', '#015AAA'],
      // circles: []
      grid: [],
      innerAxis: [
        'Strategic & Long term focus',
        'Operational & Short term focus',
        'People &\nRelationships',
        'Tasks &\nDeliverables',
      ],
    }
  },
  mounted() {
    if (this.axis.length > 0) {
      this.innerAxis = this.axis;
    }

    this.initVariables();
    this.initChart();
  },
  methods: {
    currentApp() {
      if (this.$route.params.app === 'pwc-tdc-toolkit') {
        return 'tdc';
      } else if (this.$route.params.app === 'fitt-accreditation-training') {
        return 'fat';
      }
    },
    initVariables() {
      this.width = document.getElementById(this.id).clientWidth;
      this.height = document.getElementById(this.id).clientHeight;
      this.shrinkFactor = this.width * 0.15;
    },
    initChart() {
      this.paper = Raphael(this.id, parseInt(this.width), parseInt(this.height));
      this.paper.setViewBox(0, 0, this.width, this.height, true);
      this.initAxis();
      // this.drawMainCircles();
      this.initChartValues();
      this.drawBackgroundGrid();
      this.initAutoScale();
    },
    initAxis() {
      /*this.paper.path(["M", this.width / 2, this.shrinkFactor, "L", this.width / 2, this.height - this.shrinkFactor]).attr('stroke', this.colors[2]);
      this.paper.path(["M", this.shrinkFactor, this.height / 2, "L", this.width - this.shrinkFactor, this.height / 2]).attr('stroke', this.colors[2]);*/
      this.addText(this.width / 2, this.shrinkFactor / 1.25, "white", this.innerAxis[0]);
      this.addText(this.width / 2, this.height - this.shrinkFactor / 1.25, "white", this.innerAxis[1]);
      this.addText(this.shrinkFactor / 2, this.height / 2, "white", this.innerAxis[2]);
      this.addText(this.width - this.shrinkFactor / 2, this.height / 2, "white", this.innerAxis[3]);
      this.addText((this.width * 0.25) + this.shrinkFactor / 2, ((this.height * 0.25) + this.shrinkFactor) * 0.8, 'black', this.currentApp() === 'tdc' ? 'Sustainable relationship\nbuilder' : '', "middle", (this.height - this.shrinkFactor * 2) * 0.029, '500');
      this.addText((this.width * 0.755) - this.shrinkFactor / 2, ((this.height * 0.25) + this.shrinkFactor) * 0.8, 'black', this.currentApp() === 'tdc' ? 'Focused value\ndriver' : '', "middle", (this.height - this.shrinkFactor * 2) * 0.029, '500');
      this.addText((this.width * 0.255) + this.shrinkFactor / 2, ((this.height * 0.89) - this.shrinkFactor) * 0.93, 'black', this.currentApp() === 'tdc' ? 'Diligent\ncollaborator' : '', "middle", (this.height - this.shrinkFactor * 2) * 0.029, '500');
      this.addText((this.width * 0.755) - this.shrinkFactor / 2, ((this.height * 0.89) - this.shrinkFactor) * 0.93, 'black', this.currentApp() === 'tdc' ? 'Results producer' : '', "middle", (this.height - this.shrinkFactor * 2) * 0.029, '500');
      // this.addText(this.width/2,this.shrinkFactor/2,"black","Strategic &\nLong term focus");
    },
    initAutoScale() {
      let svgs = document.querySelectorAll("svg");
      for (let svg of svgs) {
        svg.removeAttribute("width");
        svg.removeAttribute("height");
      }
    },
    drawBackgroundGrid() {
      let gridSize = 21;
      let blockSize = ((this.width - this.shrinkFactor * 2) / gridSize);
      let centerIndex = Math.ceil(gridSize / 2) - 1;

      // let quarterCount = 4;


      for (let i = 0; i < gridSize; i++) {
        for (let k = 0; k < gridSize; k++) {
          this.grid.push(this.paper.rect(k * blockSize + this.shrinkFactor, i * blockSize + this.shrinkFactor, blockSize, blockSize).attr({
            stroke: i === centerIndex || k === centerIndex ? this.primaryColor : this.secondaryColor,
            "stroke-width": 0.5,
            opacity: 0.1,
            fill: i === centerIndex || k === centerIndex ? this.primaryColor : ''
          }));
          let axistext = "";
          if (k === centerIndex && i < centerIndex) {
            axistext = Math.abs(centerIndex - i);
          }
          if (i === centerIndex && k < centerIndex) {
            axistext = Math.abs(centerIndex - k);
          }
          if (i === centerIndex && k > centerIndex) {
            axistext = Math.abs(centerIndex - k);
          }
          if (k === centerIndex && i > centerIndex) {
            axistext = Math.abs(centerIndex - i);
          }
          if (i === centerIndex || k === centerIndex) {
            this.addText(k * blockSize + this.shrinkFactor + blockSize / 2, i * blockSize + this.shrinkFactor + blockSize / 2, "white", axistext, "middle", this.height * 0.020, "350");
          }
        }
      }

      setTimeout(() => {
        this.grid.forEach((c) => {
          c.animate({opacity: 1}, 300);
        });
      }, 200);

    },
    drawMainCircles() {
      let cnt = 0;
      for (let i = 0.25; i < 1; i += 0.5) { //y
        for (let k = 0.25; k < 1; k += 0.5) {//x
          cnt++;
          let cX = 0;
          let cY = 0;

          if (cnt === 1) {
            cX = (this.width * k) + this.shrinkFactor / 2;
            cY = (this.height * i) + this.shrinkFactor / 2;
          }
          if (cnt === 2) {
            cX = (this.width * k) - this.shrinkFactor / 2;
            cY = (this.height * i) + this.shrinkFactor / 2;
          }

          if (cnt === 3) {
            cX = (this.width * k) + this.shrinkFactor / 2;
            cY = (this.height * i) - this.shrinkFactor / 2;
          }

          if (cnt === 4) {
            cX = (this.width * k) - this.shrinkFactor / 2;
            cY = (this.height * i) - this.shrinkFactor / 2;
          }
          this.circles.push(this.paper.circle(cX, cY, (this.height - this.shrinkFactor * 2) * 0.25).attr({
            fill: this.colors[cnt - 1],
            stroke: this.colors[cnt - 1],
            opacity: 0
          }));
        }
      }

      this.circles.push(this.paper.circle(this.width / 2, this.height / 2, (this.height - this.shrinkFactor * 2) * 0.23).attr({
        fill: "white",
        stroke: this.colors[0],
        opacity: 0
      }));

      this.specialText((this.width * 0.25) + this.shrinkFactor / 2, ((this.height * 0.30) + this.shrinkFactor) * 0.5, "Inspire", "to be a...", 'white', (this.height - this.shrinkFactor * 2) * 0.033);
      this.specialText((this.width * 0.755) - this.shrinkFactor / 2, ((this.height * 0.30) + this.shrinkFactor) * 0.5, "Create", "to be an...", 'white', (this.height - this.shrinkFactor * 2) * 0.033);
      this.specialText((this.width * 0.255) + this.shrinkFactor / 2, ((this.height * 0.75) - this.shrinkFactor) * 1.09, "Engage", "to be a...", 'white', (this.height - this.shrinkFactor * 2) * 0.033);
      this.specialText((this.width * 0.755) - this.shrinkFactor / 2, ((this.height * 0.75) - this.shrinkFactor) * 1.09, "Deliver", "to be an...", 'white', (this.height - this.shrinkFactor * 2) * 0.033);

      this.addText(((this.width * 0.25) + this.shrinkFactor / 2) * 0.75, ((this.height * 0.30) + this.shrinkFactor) * 0.65, "white", "Talent\nChampion", "start", this.height * 0.035, "100");
      this.addText(((this.width * 0.75) + this.shrinkFactor / 2) * 0.72, ((this.height * 0.30) + this.shrinkFactor) * 0.65, "white", "Innovation\nPioneer", "start", this.height * 0.035, "100");
      this.addText(((this.width * 0.75) + this.shrinkFactor / 2) * 0.72, ((this.height * 0.75) * 0.95), "white", "Excellence\nDriver", "start", this.height * 0.035, "100");
      this.addText(((this.width * 0.25) + this.shrinkFactor / 2) * 0.75, ((this.height * 0.75) * 0.95), "white", "Collaboration\nPartner", "start", this.height * 0.035, "100");
      this.addText(this.width / 2, this.height / 2, "black", "Be the\nimpact", "middle", this.height * 0.035, "100");

      setTimeout(() => {
        this.circles.forEach((c) => {
          c.animate({opacity: 1}, 300);
        });
      }, 200);
      /*
                      setTimeout(() => {
                          this.mapValues();
                      }, 1000)*/
    },
    initChartValues() {
      setTimeout(() => {
        this.mapValues();
      }, 1000)
    },
    addText(x, y, fill = "black", text, anchor = "middle", size = this.height * 0.02, weight = "500") {
      this.paper.text(x, y, text).attr({
        "font-weight": weight,
        "font-size": size,
        "font-family": "fontName, Roboto",
        'fill': fill,
        "text-anchor": anchor
      }).node.setAttribute("class", "donthighlight");
    },
    specialText(x, y, boldText, normalText, stroke = "white", size = 25) {
      let content = this.paper.text(x, y, "").attr({
        "font-size": size,
        "font-family": "fontName, Roboto",
        'fill': stroke,
        "text-anchor": "middle"
      });

      let txt1 = Raphael._g.doc.createTextNode(boldText ? boldText + " " : '');
      let txt2 = Raphael._g.doc.createTextNode(normalText);
      let svgNS = "http://www.w3.org/2000/svg";
      let ts1 = Raphael._g.doc.createElementNS(svgNS, "tspan");
      let ts2 = Raphael._g.doc.createElementNS(svgNS, "tspan");
      ts1.setAttribute("font-weight", "500");
      ts2.setAttribute("font-weight", "100");
      ts1.setAttribute("class", "donthighlight");
      ts2.setAttribute("class", "donthighlight");
      ts1.appendChild(txt1);
      ts2.appendChild(txt2);
      content.node.appendChild(ts1);
      content.node.appendChild(ts2);

    },
    mapValues() {
      let unitVal = ((this.height / 2) - this.shrinkFactor) / 10;
      if (!this.prevState || JSON.stringify(this.initState) === JSON.stringify(this.prevState)) {
        for (let i = 1; i <= 4; i++) {
          if (i === 1)
            this.drawValueCircles((this.width / 2), (this.height / 2), 5).animate({transform: "T" + this.getDistance((this.width / 2) + (unitVal * this.initState.t), null) + ",-" + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.s))}, 700);
          if (i === 2)
            this.drawValueCircles((this.width / 2), (this.height / 2), 5).animate({transform: "T-" + this.getDistance((this.width / 2) + (unitVal * this.initState.p), null) + ",-" + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.s))}, 700);
          if (i === 3)
            this.drawValueCircles((this.width / 2), (this.height / 2), 5).animate({transform: "T-" + this.getDistance((this.width / 2) + (unitVal * this.initState.p), null) + "," + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.o))}, 700);
          if (i === 4)
            this.drawValueCircles((this.width / 2), (this.height / 2), 5).animate({transform: "T" + this.getDistance((this.width / 2) + (unitVal * this.initState.t), null) + "," + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.o))}, 700);
        }

        setTimeout(() => {
          this.paper.rect(this.width / 2, this.height / 2, unitVal * (this.initState.t + this.initState.p), unitVal * (this.initState.s + this.initState.o)).attr({
            'stroke': this.coverAreaColor,
            'fill': this.coverAreaColor,
            'stroke-width': 5,
            'opacity': 0
          }).animate({transform: "T-" + this.getDistance((this.width / 2) + (unitVal * this.initState.p), null) + ",-" + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.s))}, 1)
              .animate({opacity: 0.3}, 100);
        }, 700);
      } else {

        for (let i = 1; i <= 4; i++) {
          if (i === 1) {

            let c = this.drawValueCircles((this.width / 2) + (this.prevState.t * unitVal), (this.height / 2) - (this.prevState.s * unitVal), 5);
            setTimeout(() => {
              c.animate({transform: "T" + this.getRealDistance((this.width / 2) + (unitVal * this.initState.t), null, (this.width / 2) + (this.prevState.t * unitVal)) + "," + this.getRealDistance(null, (this.height / 2) - (unitVal * this.initState.s), null, (this.height / 2) - (this.prevState.s * unitVal))}, 1000);
            }, 650);
          }
          if (i === 2) {
            let c = this.drawValueCircles((this.width / 2) - (this.prevState.p * unitVal), (this.height / 2) - (this.prevState.s * unitVal), 5);

            setTimeout(() => {
              c.animate({transform: "T" + this.getRealDistance((this.width / 2) - (unitVal * this.initState.p), null, (this.width / 2) - (this.prevState.p * unitVal)) + "," + this.getRealDistance(null, (this.height / 2) - (unitVal * this.initState.s), null, (this.height / 2) - (this.prevState.s * unitVal))}, 1000);
            }, 650);

          }
          if (i === 3) {
            let c = this.drawValueCircles((this.width / 2) - (this.prevState.p * unitVal), (this.height / 2) + (this.prevState.o * unitVal), 5);

            setTimeout(() => {
              c.animate({transform: "T" + this.getRealDistance((this.width / 2) - (unitVal * this.initState.p), null, (this.width / 2) - (this.prevState.p * unitVal)) + "," + this.getRealDistance(null, (this.height / 2) + (unitVal * this.initState.o), null, (this.height / 2) + (this.prevState.o * unitVal))}, 1000);
            }, 650)
          }
          if (i === 4) {
            let c = this.drawValueCircles((this.width / 2) + (this.prevState.t * unitVal), (this.height / 2) + (this.prevState.o * unitVal), 5);

            setTimeout(() => {
              c.animate({transform: "T" + this.getRealDistance((this.width / 2) + (unitVal * this.initState.t), null, (this.width / 2) + (this.prevState.t * unitVal)) + "," + this.getRealDistance(null, (this.height / 2) + (unitVal * this.initState.o), null, (this.height / 2) + (this.prevState.o * unitVal))}, 1000);
            }, 650);
          }
        }

        let rect = this.paper.rect(this.width / 2, this.height / 2, unitVal * (this.prevState.t + this.prevState.p), unitVal * (this.prevState.s + this.prevState.o)).attr({
          'stroke': this.coverAreaColor,
          'fill': this.coverAreaColor,
          'stroke-width': 5,
          'opacity': 0
        }).animate({transform: "T-" + this.getDistance((this.width / 2) + (unitVal * this.prevState.p), null) + ",-" + this.getDistance(null, (this.height / 2) - (unitVal * this.prevState.s))}, 1)
            .animate({opacity: 0.3}, 100);

        setTimeout(() => {
          rect.remove();
          setTimeout(() => {
            rect = this.paper.rect(this.width / 2, this.height / 2, unitVal * (this.initState.t + this.initState.p), unitVal * (this.initState.s + this.initState.o)).attr({
              'stroke': this.coverAreaColor,
              'fill': this.coverAreaColor,
              'stroke-width': 5,
              'opacity': 0
            }).animate({transform: "T-" + this.getDistance((this.width / 2) + (unitVal * this.initState.p), null) + ",-" + this.getDistance(null, (this.height / 2) - (unitVal * this.initState.s))}, 1)
                .animate({opacity: 0.3}, 100);
          }, 1000);
        }, 650);
      }
    },
    drawValueCircles(x, y, rad, color = this.coverAreaColor) {
      return this.paper.circle(x, y, rad).attr({
        'fill': color,
        'stroke': color,
        'opacity': 1
      });
    },
    getDistance(x = null, y = null, width = this.width / 2, height = this.height / 2) {
      if (x)
        return Math.abs(width - x);
      if (y)
        return Math.abs(height - y);
    },
    getRealDistance(x = null, y = null, width = this.width / 2, height = this.height / 2) {
      if (x)
        return x - width;
      if (y)
        return y - height;
    }
  }
}
</script>
